import { ExportBuild, ExportBuildStatus, } from "./exporter_builds/SDKExportBuild";
export class Pipeline {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(data) {
        var _a;
        this.id = data.id;
        this.workspaceId = data.workspaceId;
        this.designSystemId = data.designSystemId;
        this.name = data.name;
        this.isEnabled = data.isEnabled;
        this.exporterConfigurationProperties = data.exporterPropertyValues;
        this.eventType = data.eventType;
        this.exporterId = data.exporterId;
        this.destinations = {
            webhookUrl: data.webhookUrl,
            documentation: data.destinationSnDocs,
            s3: data.destinationS3,
            github: data.destinationGithub,
            azure: data.destinationAzure,
            gitlab: data.destinationGitlab,
            bitbucket: data.destinationBitbucket,
        };
        this.brandPersistentId = data.brandPersistentId;
        this.themePersistentIds = data.themePersistentIds;
        this.contextIds = data.contextIds;
        this.themePersistentId = data.themePersistentId;
        this.latestJobs = this.parseLatestJobs((_a = data.latestJobs) !== null && _a !== void 0 ? _a : []);
        this.isExporterDeprecated = data.isExporterDeprecated;
    }
    // return boolean if azure bitbucket gitlab and github are null
    get isBuildOnly() {
        return (this.destinations.azure === null &&
            this.destinations.bitbucket === null &&
            this.destinations.gitlab === null &&
            this.destinations.github === null);
    }
    get gitProviderType() {
        if (this.destinations.github) {
            return "github";
        }
        if (this.destinations.bitbucket) {
            return "bitbucket";
        }
        if (this.destinations.gitlab) {
            return "gitlab";
        }
        if (this.destinations.azure) {
            return "azure";
        }
        return null;
    }
    get toRemoteModel() {
        return {
            id: this.id,
            workspaceId: this.workspaceId,
            designSystemId: this.designSystemId,
            name: this.name,
            isEnabled: this.isEnabled,
            eventType: this.eventType,
            exporterPropertyValues: this.exporterConfigurationProperties,
            exporterId: this.exporterId,
            webhookUrl: this.destinations.webhookUrl,
            destinationSnDocs: this.destinations.documentation,
            destinationS3: this.destinations.s3,
            destinationGithub: this.destinations.github,
            destinationAzure: this.destinations.azure,
            destinationGitlab: this.destinations.gitlab,
            destinationBitbucket: this.destinations.bitbucket,
            brandPersistentId: this.brandPersistentId,
            themePersistentIds: this.themePersistentIds,
            contextIds: this.contextIds,
            themePersistentId: this.themePersistentId,
            isExporterDeprecated: this.isExporterDeprecated,
            latestJobs: [],
        };
    }
    get isRunning() {
        return this.latestJobs.some((job) => job.status === ExportBuildStatus.InProgress);
    }
    parseLatestJobs(latestJobs) {
        return latestJobs.map((job) => new ExportBuild(job));
    }
}
